if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        /* ==========================================================================
        CUSTOM: Product Gallery - Modal Arrow Navigation
        Added: 2026-06-08
        Search Tag: [CUSTOM_GALLERY_MODAL_ARROW_NAVIGATION]
        ========================================================================== */

        /* ==========================================================================
        CUSTOM: Product Gallery - Modal Thumbnail Navigation
        Added: 2026-06-08
        Search Tag: [CUSTOM_GALLERY_MODAL_NAVIGATION]
        ========================================================================== */
        this.addEventListener('click', (event) => {

          const prevArrow = event.target.closest('.custom-modal-arrow--prev');
          const nextArrow = event.target.closest('.custom-modal-arrow--next');

          if (prevArrow || nextArrow) {

            const thumbnails = [...this.querySelectorAll('.custom-modal-thumbnail')];

            const currentThumbnail = this.querySelector('.custom-modal-thumbnail.is-selected');

            if (!currentThumbnail) return;

            const currentIndex = thumbnails.indexOf(currentThumbnail);

            let nextIndex = currentIndex;

            if (prevArrow && currentIndex > 0) {
              nextIndex = currentIndex - 1;
            }

            if (nextArrow && currentIndex < thumbnails.length - 1) {
              nextIndex = currentIndex + 1;
            }

            thumbnails[nextIndex].click();

            // thumbnails[nextIndex].dispatchEvent(
            //   new MouseEvent('click', {
            //     bubbles: true,
            //     cancelable: true
            //   })
            // );

            return;
          }
          const thumbnail = event.target.closest('.custom-modal-thumbnail');
          if (!thumbnail) return;

          event.preventDefault();
          event.stopPropagation();

          const mediaId = thumbnail.dataset.targetMediaId;

          const targetMedia = this.querySelector(`[data-media-id="${mediaId}"]`);

          const currentActive = this.querySelector('[data-media-id].active');

          if (!targetMedia) return;

          if (currentActive === targetMedia) return;

          /* ==========================================================================
          CUSTOM: Product Gallery - Active Thumbnail Synchronization
          Added: 2026-06-08
          Search Tag: [CUSTOM_GALLERY_MODAL_ACTIVE_THUMBNAIL]
          ========================================================================== */
          this.querySelectorAll('.custom-modal-thumbnail').forEach((thumb) => {
            thumb.classList.remove('is-selected');
          });

          thumbnail.classList.add('is-selected'); //Search Tag: [CUSTOM_GALLERY_MODAL_ARROW_VISIBILITY]

          this.updateArrowVisibility();

          targetMedia.classList.add('active');

          if (currentActive) {currentActive.classList.remove('active');}
        });
        
      }

      hide() {
        this.querySelectorAll('.custom-modal-thumbnail').forEach((thumbnail) => {
          thumbnail.classList.remove('is-selected');
        });

        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      /* ==========================================================================
      CUSTOM: Product Gallery - Modal Arrow Visibility
      Added: 2026-06-08
      Search Tag: [CUSTOM_GALLERY_MODAL_ARROW_VISIBILITY]
      ========================================================================== */
      updateArrowVisibility() {
        const thumbnails = [...this.querySelectorAll('.custom-modal-thumbnail')];

        const currentThumbnail = this.querySelector('.custom-modal-thumbnail.is-selected');

        if (!currentThumbnail) return;

        const currentIndex = thumbnails.indexOf(currentThumbnail);

        const prevArrow = this.querySelector('.custom-modal-arrow--prev');
        const nextArrow = this.querySelector('.custom-modal-arrow--next');

        prevArrow.classList.remove('is-hidden');
        nextArrow.classList.remove('is-hidden');

        if (currentIndex === 0) {
          prevArrow.classList.add('is-hidden');
        }

        if (currentIndex === thumbnails.length - 1) {
          nextArrow.classList.add('is-hidden');
        }

      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

        this.querySelectorAll('.custom-modal-thumbnail').forEach((thumbnail) => {
          thumbnail.classList.remove('is-selected');
        });

        const activeThumbnail = this.querySelector(
          `.custom-modal-thumbnail[data-target-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );

        if (activeThumbnail) {
          activeThumbnail.classList.add('is-selected');
        }

        this.updateArrowVisibility(); //Search Tag: [CUSTOM_GALLERY_MODAL_ARROW_VISIBILITY] 

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
